import React from "react";

const EnergyStoredIcon = ({ size = 16, className = "text-yellow" }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 14.667h4c3.333 0 4.667-1.334 4.667-4.667V6c0-3.333-1.334-4.667-4.667-4.667H6C2.667 1.333 1.333 2.667 1.333 6v4c0 3.333 1.334 4.667 4.667 4.667"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M5.835 8.512h1.132v2.88c0 .672.334.808.74.304l2.774-3.44c.341-.42.198-.768-.318-.768H9.03v-2.88c0-.672-.333-.808-.74-.304l-2.774 3.44c-.337.424-.194.768.319.768"
        />
      </svg>
    </span>
  );
};

export default EnergyStoredIcon;
